import { MatSort, Sort } from '@angular/material/sort';
import { PageEvent } from '@angular/material/paginator';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, takeUntil } from 'rxjs/operators';

export type SortDirection = 'asc' | 'desc';

export function applySortEvent(
  sort: Sort,
  defaultSortBy: string,
  defaultSortDir: SortDirection = 'asc'
): { sortBy: string; sortDir: SortDirection } {
  return {
    sortBy: sort.active || defaultSortBy,
    sortDir: (sort.direction as SortDirection) || defaultSortDir,
  };
}

export function applyPageEvent(event: PageEvent): { pageIndex: number; pageSize: number; skip: number } {
  const pageIndex = event.pageIndex;
  const pageSize = event.pageSize;

  return {
    pageIndex,
    pageSize,
    skip: pageIndex * pageSize,
  };
}

export function bindSortChange(
  sort: MatSort,
  destroy$: Observable<void>,
  defaultSortBy: string,
  onChange: (next: { sortBy: string; sortDir: SortDirection }) => void,
  defaultSortDir: SortDirection = 'asc'
): void {
  sort.sortChange
    .pipe(takeUntil(destroy$))
    .subscribe((sortEvent: Sort) => {
      onChange(applySortEvent(sortEvent, defaultSortBy, defaultSortDir));
    });
}

export function bindDebouncedSearch(
  search$: Observable<string>,
  destroy$: Observable<void>,
  onTerm: (term: string) => void,
  debounceMs = 300
): void {
  search$
    .pipe(
      debounceTime(debounceMs),
      map((value) => value.trim()),
      distinctUntilChanged(),
      takeUntil(destroy$)
    )
    .subscribe(onTerm);
}
